"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryPin = arbitraryPin;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
function arbitraryPin(constraints = {}) {
    return fast_check_1.default.record({
        uid: constraints.uid ? fast_check_1.default.constant(constraints.uid) : fast_check_1.default.string(),
        elementUid: constraints.elementUid ? fast_check_1.default.constant(constraints.elementUid) : fast_check_1.default.string(),
        terminalUid: constraints.terminalUid ? fast_check_1.default.constant(constraints.terminalUid) : fast_check_1.default.string(),
        order: constraints.order ? fast_check_1.default.constant(constraints.order) : fast_check_1.default.integer(),
    });
}
//# sourceMappingURL=net.js.map